import type { ReactNode } from "react";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";

import { DownloadIcon, SearchIcon } from "../../../../../assets";
import { ActionButton, DetailsActions } from "../../../components/global";

type Props = {
  title: ReactNode;
  isScrolled: boolean;
  isSavingDocument: boolean;
  onOpenFindBar: () => void;
  onSaveDocument: () => void;
  onPrint: () => void;
  onDownloadWord: () => void;
};

const ModelDetailsHeaderActions = ({
  title,
  isScrolled,
  isSavingDocument,
  onOpenFindBar,
  onSaveDocument,
  onPrint,
  onDownloadWord,
}: Props) => {
  const renderActions = ({ hideLabelOnMobile = false } = {}) => (
    <>
      <ActionButton
        icon={<SearchIcon />}
        label="Buscar"
        onClick={onOpenFindBar}
        title="Abrir busca customizada (Ctrl+F)"
        hideLabelOnMobile={hideLabelOnMobile}
      />
      <ActionButton
        icon={<BookmarkBorderOutlinedIcon fontSize="small" />}
        onClick={onSaveDocument}
        disabled={isSavingDocument}
        label={isSavingDocument ? "Salvando..." : "Salvar"}
        hideLabelOnMobile={hideLabelOnMobile}
      />
      <ActionButton
        icon={<PrintOutlinedIcon fontSize="small" />}
        label="Imprimir"
        onClick={onPrint}
        hideLabelOnMobile={hideLabelOnMobile}
      />
      <ActionButton
        icon={<DownloadIcon />}
        label="Baixar em Word"
        onClick={onDownloadWord}
        hideLabelOnMobile={hideLabelOnMobile}
      />
    </>
  );

  return (
    <DetailsActions
      title={title}
      isScrolled={isScrolled}
      renderActions={renderActions}
      wrapStickyWithContainer={false}
    />
  );
};

export default ModelDetailsHeaderActions;
